import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import QuoteItem from './QuoteItem';

function QuotesTab(props) {
  var quotes = props.quotes;
  var onSuccess = props.onSuccess;
  var highlightedQuote = props.highlightedQuote;
  var onClearHighlight = props.onClearHighlight;
  
  var filterState = useState('all');
  var quoteFilter = filterState[0];
  var setQuoteFilter = filterState[1];
  
  function getSortedFilteredQuotes() {
    var statusOrder = { pending: 0, accepted: 1, responded: 2, completed: 3, declined: 4, rejected: 5, closed: 6, expired: 7 };
    var sorted = quotes.slice().sort(function(a, b) {
      var orderA = statusOrder[a.status] !== undefined ? statusOrder[a.status] : 99;
      var orderB = statusOrder[b.status] !== undefined ? statusOrder[b.status] : 99;
      if (orderA !== orderB) return orderA - orderB;
      return new Date(b.created_at) - new Date(a.created_at);
    });
    
    if (quoteFilter === 'all') return sorted;
    if (quoteFilter === 'active') return sorted.filter(function(q) { return ['pending', 'responded', 'accepted'].includes(q.status); });
    if (quoteFilter === 'completed') return sorted.filter(function(q) { return q.status === 'completed'; });
    if (quoteFilter === 'inactive') return sorted.filter(function(q) { return ['rejected', 'declined', 'closed', 'expired'].includes(q.status); });
    return sorted.filter(function(q) { return q.status === quoteFilter; });
  }
  
  var activeCount = quotes.filter(function(q) { return ['pending', 'responded', 'accepted'].includes(q.status); }).length;
  var completedCount = quotes.filter(function(q) { return q.status === 'completed'; }).length;
  var inactiveCount = quotes.filter(function(q) { return ['rejected', 'declined', 'closed', 'expired'].includes(q.status); }).length;
  var filteredQuotes = getSortedFilteredQuotes();

  return (
    <Card className="card-base">
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <CardTitle className="text-base text-white">Quote Requests</CardTitle>
          <div className="flex flex-wrap gap-2">
            <Button size="sm" variant={quoteFilter === 'all' ? 'default' : 'outline'} className={quoteFilter === 'all' ? 'btn-accent h-7 text-xs' : 'border-slate-700 h-7 text-xs'} onClick={function() { setQuoteFilter('all'); }}>All ({quotes.length})</Button>
            <Button size="sm" variant={quoteFilter === 'active' ? 'default' : 'outline'} className={quoteFilter === 'active' ? 'bg-amber-500 hover:bg-amber-600 h-7 text-xs' : 'border-slate-700 h-7 text-xs'} onClick={function() { setQuoteFilter('active'); }}>Active ({activeCount})</Button>
            <Button size="sm" variant={quoteFilter === 'completed' ? 'default' : 'outline'} className={quoteFilter === 'completed' ? 'bg-emerald-500 hover:bg-emerald-600 h-7 text-xs' : 'border-slate-700 h-7 text-xs'} onClick={function() { setQuoteFilter('completed'); }}>Completed ({completedCount})</Button>
            <Button size="sm" variant={quoteFilter === 'inactive' ? 'default' : 'outline'} className={quoteFilter === 'inactive' ? 'bg-slate-500 hover:bg-slate-600 h-7 text-xs' : 'border-slate-700 h-7 text-xs'} onClick={function() { setQuoteFilter('inactive'); }}>Inactive ({inactiveCount})</Button>
          </div>
        </div>
        <p className="text-xs text-slate-500 mt-2">Auto-archives: Pending 7d • Responded 30d • Completed 90d</p>
      </CardHeader>
      <CardContent>
        {filteredQuotes.length > 0 ? (
          <div className="space-y-4">
            {filteredQuotes.map(function(quote) {
              return <QuoteItem key={quote.id} quote={quote} onSuccess={onSuccess} isHighlighted={highlightedQuote === quote.id} onClearHighlight={onClearHighlight} />;
            })}
          </div>
        ) : (
          <p className="text-center text-slate-500 py-8">{quoteFilter === 'all' ? 'No quote requests yet' : 'No ' + quoteFilter + ' quotes'}</p>
        )}
      </CardContent>
    </Card>
  );
}

export default QuotesTab;
